import React from "react";
import {Box, Text, TextInput} from "@mantine/core";
import {IQuestionAnswerMetricStep} from "../../../types/protocol";
import {IQuestionAnswerMetricStepDefinition} from "../../../types/protocolDefinitions";
import classes from "../StepView.module.css";
import {DeepPartial} from "@/utils/types/DeepPartial";
import {TWorkflow} from "../StepView";

/** Union type for Q&A steps (both execution and planning modes) */
type QaStep = IQuestionAnswerMetricStep | IQuestionAnswerMetricStepDefinition;

export interface QaStepViewProps {
    step: QaStep;
    onChange: (updates: DeepPartial<QaStep>) => void;
    workflow?: TWorkflow;
}

/**
 * View component for Q&A steps.
 * This is the primary rendering for Q&A steps in all contexts.
 * Used in both protocol execution and planning modes.
 */
export const QaStepView: React.FC<QaStepViewProps> = ({
    step,
    onChange,
    workflow = "session",
}) => {
    const isReadOnly = workflow === "review";

    return (
        <div style={{display: "flex", flexDirection: "column", width: "100%"}}>
            <Box className={classes.qaStepViewField}>
                <Text className={classes.stepViewLabel}>Question:</Text>
                <TextInput
                    size="xs"
                    placeholder="Enter question"
                    data-testid="input-question"
                    defaultValue={step.question || ""}
                    onBlur={(e) => onChange({question: e.currentTarget.value})}
                    onClick={(e) => e.stopPropagation()}
                    disabled={isReadOnly}
                />
                <Text className={classes.stepViewLabel}>Answer:</Text>
                <TextInput
                    size="xs"
                    placeholder="Enter answer"
                    data-testid="input-answer"
                    defaultValue={step.answer || ""}
                    onBlur={(e) => onChange({answer: e.currentTarget.value})}
                    onClick={(e) => e.stopPropagation()}
                    disabled={isReadOnly}
                />
            </Box>
        </div>
    );
};